//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

export default {
    name: "AddProcessModal",
    components: {
        AQModal,
        AQButton,
        AQCard,
        FabricSearch,
        AQEmptySearch
    },
    props: {
        isSmallScreen: { type: Boolean, default: false }
    },
    data() {
        return {
            showModal: true,
            descriptionError: false,
            processes: [],
            searchVal: ""
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        getModalTitle() {
            const title = this.$t("processes.startProcess");
            return `${this.currentApp.name}/${title}`;
        }
    },
    watch: {
        searchVal: {
            handler(newValue) {
                if (newValue) {
                    const searchV = newValue ? newValue.trim() : "";
                    if (searchV && searchV.length > 2) {
                        this.getProcessList(searchV);
                    }
                } else {
                    this.getProcessList();
                }
            }
        }
    },
    mounted() {
        this.getProcessList();
    },
    deactivated() {
        this.$store.commit("apps/setCurrentApp", {});
        this.$emit("input", false);
    },
    methods: {
        ...mapActions("apps", ["getProcessesStartContext"]),
        actionsDlg($event) {
            if ($event === "close") {
                this.showModal = false;
                this.$emit("input", false);
            }
        },
        getProcessList(searchTerm) {
            const payload = {
                applicationId: this.currentApp.id,
                searchTerm: searchTerm || ""
            };
            this.getProcessesStartContext(payload).then(rsp => {
                this.processes = rsp.data;
            });
        },
        startProcess(item) {
            if (sessionStorage.getItem("wallet")) {
                sessionStorage.removeItem("wallet");
            }
            localStorage.removeItem("registerAppId");
            const applicationProps = {
                appId: item.id
            };
            this.$store.commit("components/resetState");
            this.$store.dispatch("apps/startApp", applicationProps);
        }
    }
};
